import { ReactComponent as SpinnerSvg } from "@/assets/icons/common/spinner.svg";
import { Stack } from "@mui/material";
import { twMerge } from "tailwind-merge";

interface ILoadingSpinnerProps {
	label?: string;
	className?: string;
}
export const LoadingSpinner = ({ label, className }: Readonly<ILoadingSpinnerProps>) => {
	return (
		<Stack direction="row" spacing={1} className={twMerge("font-sans text-default text-[14.5px]/[1]", className)}>
			<Stack>
				<SpinnerSvg className="animate-[spin_3s_linear_infinite]" />
			</Stack>
			{Boolean(label) && <Stack>{label}</Stack>}
		</Stack>
	);
};
